import { ChevronDown } from 'lucide-react';
import { FAQ } from '../dados/faq';
import { Secao } from './secao';
import { Reveal, RevealGrupo } from './reveal';

/**
 * `<details>`/`<summary>` nativo: acessível por teclado e leitor de tela sem
 * nenhum JavaScript de estado — a opção mais robusta para um accordion.
 */
export function Faq(): JSX.Element {
  return (
    <Secao
      adiarRender
      alturaEstimada={640}
      id="faq"
      rotulo="Perguntas frequentes"
      titulo="O que costuma perguntar antes de assinar."
    >
      <RevealGrupo
        className="border-auth-borda/8 divide-auth-borda/8 mt-12 flex flex-col divide-y border-t"
        passoMs={50}
      >
        {FAQ.map((item) => (
          <Reveal key={item.pergunta}>
            <details className="group py-5">
              {/*
                `-my-5 py-5`: o padding vertical do `<details>` vira área
                CLICÁVEL do summary sem mover um pixel — a linha media 24px de
                alvo de toque (o padding morava no pai, fora do clique), e o
                acordeão é dedo em celular. Margem negativa e padding se
                anulam no layout; só o hit-box cresce.
              */}
              <summary className="text-auth-texto marker:content-none -my-5 flex cursor-pointer list-none items-center justify-between gap-4 py-5 text-base font-normal">
                {item.pergunta}
                <ChevronDown
                  size={18}
                  className="text-auth-texto-terciario shrink-0 transition-transform duration-200 group-open:rotate-180"
                  aria-hidden
                />
              </summary>
              <p className="text-auth-texto-secundario mt-3 max-w-2xl text-sm leading-relaxed">
                {item.resposta}
              </p>
            </details>
          </Reveal>
        ))}
      </RevealGrupo>
    </Secao>
  );
}
